module.exports = __webpack_public_path__ + "img/male6.849422d3.jpg";